import React, { CSSProperties, useState } from 'react';
import './image-tile.css';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import ModalVideo from 'react-modal-video';
import { consentContext } from '../../context/ConsentContext';
import { IGatsbyImageData } from 'gatsby-plugin-image/dist/src/components/gatsby-image.browser';
import { WpCoreImageBlock } from '../../../generated/graphql';

export type ImageTileBlock = WpCoreImageBlock & {
  attributes?: {
    imageFluid: any;
    alt: string;
    caption?: string;
  };
  url: string;
  localUrl: string;
  localFullUrl: string | undefined;
};

interface ImageTileProps {
  image?: ImageTileBlock;
  content?: string;
  caption?: string;
  href?: string;
  linkTarget?: string;
  styleClass?: string;
  onClickCallback?: () => void;
}

const ConditionalWrapper = ({ condition, wrapper, children }) =>
  condition ? wrapper(children) : children;

const getVidId = (url: string) => {
  // TODO: check if more posibilities are needed
  let videoId = '';
  if (url && url.indexOf('youtube') >= 0 && url.indexOf('v=') >= 0) {
    videoId = url.split('v=')[1];
    const ampersandPosition = videoId.indexOf('&');
    if (ampersandPosition != -1) {
      videoId = videoId.substring(0, ampersandPosition);
    }
  } else if (url && url.indexOf('youtu.be') >= 0) {
    videoId = url.split('youtu.be/')[1];
  } else if (url && url.indexOf('youtube') >= 0 && url.indexOf('embed') >= 0) {
    videoId = url.split('embed/')[1];
  }
  return videoId;
};

function ImageTile({
  image,
  caption,
  href,
  styleClass,
  linkTarget,
  onClickCallback,
  content,
}: ImageTileProps): JSX.Element {
  const [isOpen, setIsOpen] = useState(false);

  // console.log(href + ' : ' + getVidId(href as string));
  const alt = image ? image.attributes?.alt : '';
  // console.log('IMAGE', image);

  function isYoutubeLink(href) {
    return href.indexOf('youtube') >= 0 || href.indexOf('youtu.be') >= 0;
  }

  let gatsbyImage: IGatsbyImageData | undefined = undefined;
  if (image?.attributes?.imageFluid?.childImageSharp?.full) {
    gatsbyImage = getImage(image.attributes.imageFluid.childImageSharp.full);
  } else if (image?.attributes?.imageFluid?.childImageSharp?.gatsbyImageData) {
    gatsbyImage = getImage(image.attributes.imageFluid.childImageSharp);
  }
  const width = image?.attributes?.width;
  const height = image?.attributes?.height;

  const style: CSSProperties = {};
  if (width && height && !styleClass) {
    style.width = width;
    style.height = height;
  }

  return (
    <consentContext.Consumer>
      {(context) =>
        href && isYoutubeLink(href) && context.cookieConsent === false ? (
          <div className="image-tile-youtube-no-consent">
            <p>
              Bitte die Cookie-Einstellungen anpassen und
              <b> Externe Medien </b>
              zulassen, um diesen Inhalt sehen zu können.
            </p>
            <button
              className="image-tile-youtube-no-consent-button"
              onClick={context.showModal}
            >
              Cookie Einstellungen
            </button>
          </div>
        ) : (
          <div className={`image-tile ${styleClass ?? ''}`}>
            <ConditionalWrapper
              condition={href}
              wrapper={(children) => {
                return (
                  (href && isYoutubeLink(href) && context.cookieConsent && (
                    <div>
                      <a
                        className="image-tile__link"
                        onClick={(e) => {
                          e.preventDefault();
                          setIsOpen(true);
                        }}
                      >
                        {children}
                      </a>
                      <ModalVideo
                        channel="youtube"
                        isOpen={isOpen}
                        autoPlay={1}
                        videoId={getVidId(href as string)}
                        onClose={() => {
                          setIsOpen(false);
                        }}
                      />
                    </div>
                  )) || (
                    <a
                      className="image-tile__link"
                      target={linkTarget}
                      href={href}
                    >
                      {children}
                    </a>
                  )
                );
              }}
            >
              <div
                className="image-tile__meta"
                onClick={() => onClickCallback && onClickCallback()}
              >
                {gatsbyImage && (
                  <>
                    <div className="image-tile__image-container" style={style}>
                      <GatsbyImage image={gatsbyImage} alt={alt ?? ''} />
                    </div>
                    {caption && (
                      <div className={`image-tile__caption`}>
                        <div dangerouslySetInnerHTML={{ __html: caption }} />
                      </div>
                    )}
                  </>
                )}
                {!gatsbyImage && content && (
                  <div className="image-tile__image-container">
                    <div dangerouslySetInnerHTML={{ __html: content }} />
                  </div>
                )}
              </div>
            </ConditionalWrapper>
          </div>
        )
      }
    </consentContext.Consumer>
  );
}

export default ImageTile;
